import { memo } from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import type { GownRentalItem } from "../../types/rental.types";

interface PickupGownItemsListProps {
  items: GownRentalItem[];
}

/**
 * Lista read-only dos itens de beca do aluguel — usada no dialog de
 * retirada para tipo GOWN. Cada linha é clicável e leva para a página
 * de detalhe do produto (`/produtos/:id`). Não faz fetch — `productName`
 * já vem enriquecido pela API no payload do aluguel.
 */
export const PickupGownItemsList = memo(function PickupGownItemsList({
  items,
}: PickupGownItemsListProps) {
  if (items.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Sem itens vinculados ao aluguel.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item.idGownRentalItem}>
          <Link
            to={`/produtos/${item.productId}`}
            className="flex items-center gap-3 rounded-md border border-input bg-background p-3 text-sm hover:bg-accent transition-colors"
          >
            {item.photoUrl ? (
              <img
                src={item.photoUrl}
                alt=""
                className="w-10 h-10 rounded object-cover"
              />
            ) : null}
            <span className="flex-1 truncate">{item.productName}</span>
            <span className="text-muted-foreground">{item.quantity} un.</span>
            <ExternalLink
              className="w-3.5 h-3.5 text-muted-foreground shrink-0"
              aria-hidden="true"
            />
          </Link>
        </li>
      ))}
    </ul>
  );
});
